module.exports = __webpack_public_path__ + "static/media/ISAMM_Site.29d5eb8b.png";